const initGetFunction = (api, baseUrl) => async (query = '') => {
  const result = await api.get(baseUrl + query);
  return result;
};

const initSaveFunction = (api, baseUrl, idField) => async (requestBody) => {
  const result = await api.post(`${baseUrl}/${requestBody[idField] || 0}`, requestBody);
  return result;
};

const initRemoveFunction = (api, baseUrl, idField) => async (requestBody) => {
  const result = await api.del(`${baseUrl}/${requestBody[idField] || 0}`, requestBody);
  return result;
};

const initExportFunction = (api, baseUrl, idField = 'id') => {
  const get = initGetFunction(api, baseUrl);
  const save = initSaveFunction(api, baseUrl, idField);
  const remove = initRemoveFunction(api, baseUrl, idField);

  return [get, save, remove];
};

// страница "Источники финансирования"
export const useAPIAgreement = (api) => initExportFunction(api, '/mng/agreements');
export const useAPIBudgetCode = (api) => initExportFunction(api, '/mng/bcCodes');
export const useAPIType = (api) => initExportFunction(api, '/mng/funding');
export const useAPIStatementEvents = (api) => initExportFunction(api, '/mng/letters', 'code');
export const useAPICostAgreements = (api) => initExportFunction(api, '/mng/cost/agrs');
export const useAPICostKvrs = (api) => initExportFunction(api, '/mng/cost/kvrs');

// страница "Планы по источникам финансирования"
export const useAPIAgreementPlan = (api) => initExportFunction(api, '/mng/agreements/0/plans');
export const useAPIStratProjectsPlan = (api) => initExportFunction(api, '/mng/strategies/0/plans');
export const useAPICostAgrsPlan = (api) => initExportFunction(api, '/mng/cost/agrs/0/plans');
export const useAPICostKvrPlan = (api) => initExportFunction(api, '/mng/cost/kvrs/0/plans');

export const useAPIAgreementKpsCodes = (api) => {
  const baseUrl = '/mng/kpsCodes';
  const idField = 'id';

  const get = (agreementId) => initGetFunction(api, `/mng/agreements/${agreementId}/kpsCodes`)();
  const save = initSaveFunction(api, baseUrl, idField);
  const remove = initRemoveFunction(api, baseUrl, idField);

  return [get, save, remove];
};
